<div #darkBackground class="black-background" (click)="onCloseModal()">
  <div class="contenedor-form-login" (click)="$event.stopPropagation()">
    <!-- SOCIAL LOGIN BUTTONS -->
    <div class="socials">
      <asl-google-signin-button class="asl-signin" type="standard" shape="pill" text="continue_with" size="large" theme="outline">
        <div id="g_id_onload" data-client_id="test" data-context="signin" data-ux_mode="popup" data-login_uri="https://test.com" data-auto_prompt="false"></div>

        <div class="g_id_signin" data-type="standard" data-shape="pill" data-theme="outline" data-text="continue_with" data-size="large" data-logo_alignment="left"></div>
      </asl-google-signin-button>
    </div>

    <div class="separador-socials">
      <hr />
      <span>O</span>
      <hr />
    </div>

    <h1>
      Inicia sesión
      <span class="nombre-periodico"
        >en {{ constantesGlobales.siteName }}
        <!--      <img src="assets/images/{{constantesGlobales.logoMovil}}" loading="lazy" width="100%" height="100%">-->
      </span>
    </h1>
    <form [formGroup]="loginForm" class="form-login" (ngSubmit)="sendLogin()">
      <div class="form-field">
        <input required type="email" id="email" formControlName="email" placeholder="login@example.com" [class.invalid]="emailFormControl.invalid && emailFormControl.touched" />
        <label for="email">Email<ng-container *ngIf="emailFormControl.hasValidator(required)"> * </ng-container></label>
        <ng-container *ngIf="emailFormControl.hasError('email') && !emailFormControl.hasError('required')">
          <span class="error-message">Por favor, introduce un email válido.</span>
        </ng-container>
        <ng-container *ngIf="emailFormControl.hasError('required')">
          <span class="error-message">El email es <strong>obligatorio</strong></span>
        </ng-container>
      </div>

      <div class="form-field">
        <input required type="password" id="password" formControlName="password" placeholder=" " [class.invalid]="passwordFormControl.invalid && passwordFormControl.touched" />
        <label for="password">Contraseña<ng-container *ngIf="passwordFormControl.hasValidator(required)"> * </ng-container></label>
        <ng-container *ngIf="passwordFormControl.hasError('required')">
          <span class="error-message">La contraseña es <strong>obligatoria</strong></span>
        </ng-container>
      </div>

      <button class="btn-login" type="submit">Iniciar Sesión</button>
      <div class="btn-registro" (click)="openRegistroDialog()">¿No tiene cuenta? Registrese aquí.</div>
    </form>
  </div>
</div>
